<div class="container-fuid bg-white default-boxrounded">
  <div class="row">
    <div class="col-12 w-100">
      <h3 class="title"><span translate="Support.CreateNewSupportTicket"></span></h3>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="mx-4 my-1">
      <div class="mt-2">
        <label for="summary" class="form-label text-truncate d-block"
          translate="Support.Summary">
        </label>
        <input type="text" class="form-control default" id="summary" formControlName="supportSummaryControl" [formControl]="summaryControl">
        <app-formcontrol-error-messages [forControl]="summaryControl"></app-formcontrol-error-messages>

      </div>
      <div class="my-2">
        <label for="description" class="form-label text-truncate d-block"
          translate="Support.Description">
        </label>
        <textarea class="form-control default" id="description" rows="5" formControlName="supportDescriptionControl" [formControl]="descriptionControl"></textarea>
        <app-formcontrol-error-messages [forControl]="descriptionControl"></app-formcontrol-error-messages>
      </div>
      <div class="my-2">
        <label for="attachments" class="form-label text-truncate d-block" translate="Support.Attachments"></label>
        <input type="file" id="attachments" class="d-none" multiple (change)="onFilesSelected($event)">
        <div class="form-control d-flex align-items-center p-0 overflow-hidden">
          <label for="attachments"
            class="m-0 bg-body-tertiary border-end flex-shrink-0"
            style="padding: 0.375rem 0.75rem; cursor: pointer; align-self: stretch; display: flex; align-items: center;"
            translate="Support.ChooseFile">
          </label>
          @if (attachments.length === 0) {
            <span class="text-muted text-truncate flex-grow-1" style="padding: 0.375rem 0.75rem;" translate="Support.NoFileChosen"></span>
          }
          @if (attachments.length > 0) {
            <span class="text-truncate flex-grow-1 text-truncate" style="padding: 0.375rem 0.75rem;">
              @for (attachment of attachments; track attachment; let isLast = $last) {
                {{ attachment.name }}{{ !isLast ? ', ' : '' }}
              }
            </span>
          }
        </div>
        <div class="mt-2 border rounded p-2 bg-light"
          (drop)="onFilesDropped($event)"
          (dragover)="$event.preventDefault()"
          style="min-height: 60px; cursor: pointer;">
          @if (attachments.length === 0) {
            <span class="text-muted" translate="Support.DragDropOrClick"></span>
          }
          @if (attachments.length > 0) {
            <ul class="mb-0 ps-3">
              @for (file of attachments; track file; let i = $index) {
                <li>
                  {{ file.name }}
                  <button type="button" class="btn btn-link btn-sm text-danger p-0 ms-2" (click)="removeAttachment(i)">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      </div>
      <div class="my-4 d-table w-100">
        <span class="float-start">
          <button class="float-start btn btn-sm btn-outline-primary" (click)="close()" translate="Button.Close"></button>
        </span>
        <span class="float-end">
          <button class="float-end btn btn-sm btn-primary" type="submit" [disabled]="isMakingSupportTicket" (click)="sendSupportTicket()" translate="Button.SendSupportTicket"></button>
        </span>
      </div>
    </div>
  </form>
</div>